'use client';

import { c as _c } from "react/compiler-runtime";
import { createLocalizedPath } from '../i18n-utils';
import { useCurrentLanguage } from './use-current-language';
export function useLocalizedPath() {
  const $ = _c(2);
  const language = useCurrentLanguage();
  let t0;
  if ($[0] !== language) {
    t0 = path => createLocalizedPath(language, path);
    $[0] = language;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}